/**
 * @deprecated Will be removed soon
 */
export { useWait, Waiter } from 'react-wait';
